"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import FormInput from "../../../components/FormInput";
import Button from "../../../components/Button";
import styles from "../../branchManagement/css/dashboard.module.css";
import formStyles from "../../branchManagement/css/addbranch.module.css";
import cmOverrides from "../css/companyOverrides.module.css";
import { getCompany, saveCompany } from "../../../api/companyManagement/companyManagement";

export default function CompanyForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    cipcregistrationnumber: "",
    companyname: "",
    sapcpharmacyregnumber: "",
    vatnumber: "",
    companyaddress: "",
    companyphonenumber: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getCompany();
        if (mounted && data) {
          setFormData({
            cipcregistrationnumber: data.cipcregistrationnumber || "",
            companyname: data.companyname || "",
            sapcpharmacyregnumber: data.sapcpharmacyregnumber || "",
            vatnumber: data.vatnumber || "",
            companyaddress: data.companyaddress || "",
            companyphonenumber: data.companyphonenumber || "",
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (name) => (e) => {
    setFormData({ ...formData, [name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await saveCompany(formData);
      // Optionally show a success message or navigate
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar />

        <main className={styles.content}>
          <h1 className={`${formStyles.pageTitle} ${cmOverrides.tightHeader}`}></h1>

          <form className={`${formStyles.formContainer} ${cmOverrides.raiseUp} ${cmOverrides.raiseUpTransform}`} onSubmit={handleSubmit}>
            <div className={formStyles.formRow}>
              <FormInput
                label="CIPC Registration Number"
                name="cipcregistrationnumber"
                value={formData.cipcregistrationnumber}
                onChange={handleChange("cipcregistrationnumber")}
              />
              <FormInput
                label="Company Name"
                name="companyname"
                value={formData.companyname}
                onChange={handleChange("companyname")}
              />
              <FormInput
                label="SAPC Pharmacy Reg Number"
                name="sapcpharmacyregnumber"
                value={formData.sapcpharmacyregnumber}
                onChange={handleChange("sapcpharmacyregnumber")}
              />
            </div>

            <hr className={formStyles.sectionDivider} />

            <div className={formStyles.formRow}>
              <FormInput
                label="VAT Number"
                name="vatnumber"
                value={formData.vatnumber}
                onChange={handleChange("vatnumber")}
              />
              <FormInput
                label="Company Address"
                name="companyaddress"
                value={formData.companyaddress}
                onChange={handleChange("companyaddress")}
              />
              <FormInput
                label="Company Phone Number"
                name="companyphonenumber"
                value={formData.companyphonenumber}
                onChange={handleChange("companyphonenumber")}
              />
              {/* No director field in schema; keeping the form minimal */}
            </div>

            <div className={formStyles.formActions}>
              <Button variant="primary" type="submit" disabled={saving || loading}>{saving ? "Saving..." : "Save"}</Button>
            </div>
          </form>
        </main>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
